import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    name: 'Martín Rodríguez',
    role: 'Diseñador Gráfico',
    city: 'Córdoba',
    text: 'Mandé 8 mensajes del Pack de Reactivación el lunes. El miércoles tenía 3 conversaciones abiertas y el viernes cerré 1 cliente. Nunca pensé que un PDF me iba a cambiar el mes.'
  }, {
    name: 'Camila Fernández',
    role: 'Community Manager',
    city: 'Buenos Aires',
    text: 'Llevaba 3 semanas sin que entrara nada. El Capítulo 4 me hizo escribirle a 5 ex-clientes. Dos respondieron ese mismo día. Uno contrató la semana siguiente.'
  }, {
    name: 'Diego Salinas',
    role: 'Consultor de Marketing',
    city: 'Rosario',
    text: "Lo que más me sirvió fue el Guion Anti-Objeciones. Siempre que me decían 'no tengo plata' bajaba el precio o me rendía. Ahora tengo la respuesta lista y cerré 2 clientes que antes hubiera perdido."
  }, {
    name: 'Lucía Mammone',
    role: 'Arquitecta',
    city: 'Mendoza',
    text: 'En 10 días: 15 mensajes enviados, 6 respuestas, 3 propuestas abiertas, 2 cierres. La inversión se multiplicó por 8 en la primera semana.'
  }, {
    name: 'Sebastián Torres',
    role: 'Contador Público',
    city: 'Buenos Aires',
    text: 'Pensé que era otro ebook más. Pero cuando vi los scripts de WhatsApp listos para copiar entendí que esto era diferente. Lo bajé a las 11 de la noche y a las 11 y media ya había mandado 3 mensajes.'
  }];
  return <section className="py-24 bg-white border-y border-neutral-200" data-id="element-387">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-388">
        <div className="text-center mb-16" data-id="element-389">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-390">
            Lo que dicen los que ya lo aplicaron
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-391">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-cream rounded-xl p-8 border border-neutral-200 shadow-sm flex flex-col ${i === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-392">
              <div className="flex gap-1 mb-6" data-id="element-393">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-brand-500 text-brand-500" data-id="element-394" />)}
              </div>
              <p className="text-neutral-700 text-lg mb-8 flex-grow italic font-display" data-id="element-395">
                "{t.text}"
              </p>
              <div className="border-t border-neutral-200 pt-4" data-id="element-396">
                <p className="font-bold text-neutral-900" data-id="element-397">{t.name}</p>
                <p className="text-brand-600 text-sm" data-id="element-398">
                  {t.role} · {t.city}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};